import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
// import { Link, useNavigate } from 'react-router-dom'
import axios from 'axios'
import { Container, Row, Col, Form } from 'react-bootstrap';
import './CRUDTouchs.css';
import { Server_URL } from "../config.js";

function CreateTouch() {
  const navigate = useNavigate();
  const [values, setValues] = useState({
    SNo: '', Size: '', PartNo: '', Ratio: '',
    CoverOD: '', LcmAA: '', CoverVA: '', CoverThick: '',
    SensorOD: '', SensorAA: '', SensorThick: '',
    ChannelRxTx: '', ControlIC: '',
    CGParam: '', SensorPN: '', CustomerPN: '',
    ConnectorType: '', FpcType: '',
    FWConfig: '', FWDownload: '', FWUpgrade: '', FWVersion: '',
    Resolution: '', Original: '', TestBoard: '', TestDate: '',
    RegistDate: '', Note: ''
  })

  // console.log("get into /CreateTouch()");
  // console.log("get into /CreateSensor() values :", values);

  function handleSubmit(e) {
    // console.log("get into /CreateTouch Submit values :", values);
    e.preventDefault()
    axios
      .post(`${Server_URL}/add_touch`, values)
      // .post('http://localhost:3022/add_touch', values)
      // .post('http://localhost:5000/add_touch', values)
      .then((res) => { navigate(-1) })
      // .then((res) => { navigate('/CRUDTouchs') })
      // .then((res) => { navigate('/'); console.log(res); })
      .catch((err) => console.log(err))
  }

  return (
    <div className='vh-100 vw-100 bg-info-subtle'>
      <Container className='container-fluid'>
        <Row>
          <div className='d-flex justify-content-center'> <h2>Add Touch Panel</h2> </div>
        </Row>
        <Row>
          <Col className='col-md-6 justify-content-start'>
            <button className='btn btn-success' onClick={() => navigate(-1)}>Back</button>
          </Col>
          <Col className='col-md-6'> </Col>
        </Row>
      </Container>
      <Container className='container-fluid vh-80 vw-100 bg-primary-subtle'>
        <Form onSubmit={handleSubmit}>
          <br />
          <Row>
            <Col className='col-md-2'>
              <label htmlFor='SNo'>SNo : </label>
              <input type='number' onChange={(e) => setValues({ ...values, SNo: e.target.value })} required />
            </Col>
            <Col className='col-md-3'>
              <label htmlFor='Size'>Size : </label>
              <input type='text25' onChange={(e) => setValues({ ...values, Size: e.target.value })} required />
            </Col>
            <Col className='col-md-4'>
              <label htmlFor='PartNo'>PartNo : </label>
              <input type='text75' onChange={(e) => setValues({ ...values, PartNo: e.target.value })} required />
            </Col>
            <Col className='col-md-3'>
              <label htmlFor='Ratio'>Ratio : </label>
              <input type='text25' onChange={(e) => setValues({ ...values, Ratio: e.target.value })} />
            </Col>
          </Row>
          <br />
          <Row>
            <Col className='col-md-3'>
              <label htmlFor='CoverOD'>CoverOD : </label>
              <input type='text65' onChange={(e) => setValues({ ...values, CoverOD: e.target.value })} />
            </Col>
            <Col className='col-md-3'>
              <label htmlFor='LcmAA'>LcmAA : </label>
              <input type='text65' onChange={(e) => setValues({ ...values, LcmAA: e.target.value })} required />
            </Col>
            <Col className='col-md-3'>
              <label htmlFor='CoverVA'>'CoverVA : </label>
              <input type='text65' onChange={(e) => setValues({ ...values, CoverVA: e.target.value })} />
            </Col>
            <Col className='col-md-3'>
              <label htmlFor='CoverThick'>CoverThick : </label>
              <input type='text25' onChange={(e) => setValues({ ...values, CoverThick: e.target.value })} />
            </Col>
          </Row>
          <br />
          <Row>
            <Col className='col-md-3'>
              <label htmlFor='SensorOD'>SensorOD : </label>
              <input type='text65' onChange={(e) => setValues({ ...values, SensorOD: e.target.value })} />
            </Col>
            <Col className='col-md-3'>
              <label htmlFor='SensorAA'>SensorAA : </label>
              <input type='text65' onChange={(e) => setValues({ ...values, SensorAA: e.target.value })} />
            </Col>
            <Col className='col-md-3'>
              <label htmlFor='SensorThick'>'SensorThick : </label>
              <input type='text25' onChange={(e) => setValues({ ...values, SensorThick: e.target.value })} />
            </Col>
            <Col className='col-md-3'> </Col>
          </Row>
          <br />
          <Row>
            <Col className='col-md-6'>
              <label htmlFor='ChannelRxTx'>ChannelRxTx : </label>
              <input type='text75' onChange={(e) => setValues({ ...values, ChannelRxTx: e.target.value })} />
            </Col>
            <Col className='col-md-6'>
              <label htmlFor='ControlIC'>ControlIC : </label>
              <input type='text75' onChange={(e) => setValues({ ...values, ControlIC: e.target.value })} />
            </Col>
          </Row>
          <br />
          <Row>
            <Col className='col-md-3'>
              <label htmlFor='CGParam'>CGParam : </label>
              <input type='text65' onChange={(e) => setValues({ ...values, CGParamx: e.target.value })} />
            </Col>
            <Col className='col-md-3'>
              <label htmlFor='SensorPN'>SensorPN : </label>
              <input type='text50' onChange={(e) => setValues({ ...values, SensorPN: e.target.value })} />
            </Col>
            <Col className='col-md-3'>
              <label htmlFor='CustomerPN'>'CustomerPN : </label>
              <input type='text50' onChange={(e) => setValues({ ...values, CustomerPN: e.target.value })} />
            </Col>
          </Row>
          <br />
          <Row>
            <Col className='col-md-6'>
              <label htmlFor='ConnectorType'>ConnectorType : </label>
              <input type='text75' onChange={(e) => setValues({ ...values, ConnectorType: e.target.value })} />
            </Col>
            <Col className='col-md-6'>
              <label htmlFor='FpcType'>'FpcType : </label>
              <input type='text75' onChange={(e) => setValues({ ...values, FpcType: e.target.value })} />
            </Col>
          </Row>
          <br />
          <Row>
            <Col className='col-md-3'>
              <label htmlFor='FWConfig '>FWConfig  : </label>
              <input type='text60' onChange={(e) => setValues({ ...values, FWConfig: e.target.value })} />
            </Col>
            <Col className='col-md-3'>
              <label htmlFor='FWDownload'>FWDownload : </label>
              <input type='text60' onChange={(e) => setValues({ ...values, FWDownload: e.target.value })} />
            </Col>
            <Col className='col-md-3'>
              <label htmlFor='FWUpgrade'>'FWUpgrade : </label>
              <input type='text60' onChange={(e) => setValues({ ...values, FWUpgrade: e.target.value })} />
            </Col>
            <Col className='col-md-3'>
              <label htmlFor='FWVersion'>FWVersion : </label>
              <input type='text60' onChange={(e) => setValues({ ...values, FWVersion: e.target.value })} />
            </Col>
          </Row>
          <br />
          <Row>
            <Col className='col-md-3'>
              <label htmlFor='Resolution'>Resolution : </label>
              <input type='text60' onChange={(e) => setValues({ ...values, Resolution: e.target.value })} />
            </Col>
            <Col className='col-md-3'>
              <label htmlFor='Original'>Original : </label>
              <input type='text60' onChange={(e) => setValues({ ...values, Original: e.target.value })} />
            </Col>
            <Col className='col-md-3'>
              <label htmlFor='TestBoard'>'TestBoard : </label>
              <input type='text60' onChange={(e) => setValues({ ...values, TestBoard: e.target.value })} />
            </Col>
            <Col className='col-md-3'>
              <label htmlFor='TestDate'>TestDate : </label>
              <input type='text60' onChange={(e) => setValues({ ...values, TestDate: e.target.value })} />
            </Col>
          </Row>
          <br />
          <Row>
            <Col className='col-md-3'>
              <label htmlFor='RegistDate'>RegistDate : </label>
              <input type='text50' onChange={(e) => setValues({ ...values, RegistDate: e.target.value })} />
            </Col>
            <Col className='col-md-6'>
              <label htmlFor='Note'>Note : </label>
              <input type='text75' onChange={(e) => setValues({ ...values, Note: e.target.value })} />
            </Col>
          </Row>
          <br />
          <Row className='row'>
            <Col className='col-md-3 d-flex justify-content-start'>
              <button type='submit' className='btn btn-success'>Save</button>
            </Col>
            <Col className='col-md-3 form-group my-2'> </Col>
            <Col className='col-md-3 form-group my-2'> </Col>
            <Col className='col-md-3 form-group my-2'> </Col>
          </Row>
        </Form>
      </Container>
    </div>
  )
}

export default CreateTouch